<template>
  <el-select
    v-bind="$attrs"
    v-bind:value="value"
    v-on="changeListeners"
  >
    <el-option
      v-for="option in optionArray"
      :label="option.label"
      :value="option.value"
      :key="option.value"
    ></el-option>
  </el-select>
</template>

<script>
import { taxIndicationOptions, saleTaxOptions } from "./static";

export default {
  name: "tax-select",
  props: {
    value: {
      required: true,
    },
    isSaleOption: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      taxIndicationOptions,
      saleTaxOptions,
    };
  },
  computed: {
    changeListeners() {
      const vm = this;
      return Object.assign(
        {},
        this.$listeners,
        {
          change: function(_value) {
            vm.$emit("change", _value);
          }
        }
      );
    },
    optionArray() {
      return this.isSaleOption ? this.saleTaxOptions : this.taxIndicationOptions;
    }
  },
};
</script>
